<script setup lang="tsx">
import { computed } from 'vue'
import AdLogin from './AdLogin.vue'
import IdLogin from './IdLogin.vue'
import PasswordLogin from './PasswordLogin.vue'

const props = defineProps<{
	firstLogin: boolean
	adEnabled: boolean
}>()

const showAd = computed(() => !props.firstLogin && props.adEnabled)
const showId = computed(() => window.isSecureContext)

function success() {
	location.pathname = 'app'
}
</script>

<template>
	<ul v-if="showAd || showId" class="nav nav-tabs nav-fill mt-3" role="tablist">
		<li v-if="showAd" class="nav-item" role="presentation">
			<button
				class="nav-link"
				:class="{ active: showAd }"
				id="ad-login-tab"
				data-bs-toggle="tab"
				data-bs-target="#ad-login"
				type="button"
				role="tab"
				aria-controls="ad-login"
				aria-selected="false"
			>
				Active Directory
			</button>
		</li>
		<li class="nav-item" role="presentation">
			<button
				class="nav-link"
				:class="{ active: !showAd }"
				id="pwd-login-tab"
				data-bs-toggle="tab"
				data-bs-target="#pwd-login"
				type="button"
				role="tab"
				aria-controls="pwd-login"
				aria-selected="true"
			>
				{{ $t('password') }}
			</button>
		</li>
		<li v-if="showId" class="nav-item" role="presentation">
			<button
				class="nav-link"
				id="id-login-tab"
				data-bs-toggle="tab"
				data-bs-target="#id-login"
				type="button"
				role="tab"
				aria-controls="id-login"
				aria-selected="false"
			>
				{{ $t('idCard') }}
			</button>
		</li>
	</ul>
	<div class="d-flex justify-content-center mt-5">
		<div class="tab-content">
			<div v-if="showAd" class="tab-pane fade" :class="{ active: showAd, show: showAd }" id="ad-login" role="tabpanel">
				<AdLogin @success="success"></AdLogin>
			</div>
			<div id="pwd-login" class="tab-pane fade" :class="{ active: !showAd, show: !showAd }" role="tabpanel">
				<PasswordLogin :first-login="props.firstLogin" @success="success"></PasswordLogin>
			</div>
			<div v-if="showId" id="id-login" class="tab-pane fade" role="tabpanel">
				<IdLogin @success="success"></IdLogin>
			</div>
		</div>
	</div>
</template>

<style lang="sass" scoped>
@import nav
</style>
